import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Subject} from 'rxjs';
import {navigationUrlForApplicationErrorPage} from '../service/navigation-urls';
import {catchError, tap} from 'rxjs/operators';
import {ApplicationService, } from '../service/application.service';
import {ApplicationTypes} from '@portal-workspace/grow-shared-library';
import {inject} from '@angular/core';

export const applicationErrorPageNavigation = (router: Router,applicationId: number,queryParams: { [key: string]: string | string[] | undefined; } | undefined)  => {
  return router.createUrlTree(navigationUrlForApplicationErrorPage(applicationId),{queryParams});
}


export const validApplicationTypeGuard = (
  applicationType: ApplicationTypes,
  applicationErrorCode: 'e-not-business' | 'e-not-trade' | 'e-not-invoice' | 'e-not-insurance' | 'e-not-floorplan' | 'e-not-corporate' | 'e-not-consumer' | 'e-not-commercial' | 'e-not-asset',
): CanActivateFn => {



  return (
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ) => {
    const applicationService = inject(ApplicationService);
    const router = inject(Router);
    const applicationId = route.params.applicationId;
     
    if (!!!applicationId) {
      return applicationErrorPageNavigation(router,applicationId,{type: 'e1'});
    }

    const subject = new Subject<boolean | UrlTree>();
    const sub = applicationService.getApplicationById(applicationId).pipe(
      tap(r => {
        const application = r.payload;
        if (!application) {
          subject.next(applicationErrorPageNavigation(router,applicationId,{type: 'e-general'}));
          subject.complete();
           
        } else if (application && application.ApplicationType !== applicationType) {
          subject.next(applicationErrorPageNavigation(router,applicationId,{type: applicationErrorCode}));
          subject.complete();
        } else if (application && application.Status !== 'Draft') {
          subject.next(applicationErrorPageNavigation(router,applicationId,{type: 'e-not-draft'}));
          subject.complete();
        } else {
          subject.next(true);
          subject.complete();
        }
      }),
      catchError(e => {
        console.log(e);
        subject.next(applicationErrorPageNavigation(router,applicationId,{type: 'e-general'}));
        subject.complete();
        throw e;
      })
    ).pipe().subscribe();
    return subject;
  }
}
